
export const VERSION = '5.4.18'; // Update this manually on each release

